import { Modal } from 'antd'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useStore } from 'store/useStore'
import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { Order } from 'sections/LKSection/modules/OrderModule/stores/entity/Order'
import { ConfirmedToOpen } from 'sections/LKSection/modules/OrderModule/types'
import { Checkbox, Flex, Text } from 'components/uiKit'
import { LKRoutesEnum } from 'shared/constants/routes'

type ConfirmOrderModalProps = {
  order: Order
  open: boolean
  isMove: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  setIsConfirmed: React.Dispatch<React.SetStateAction<boolean>>
}

export const ConfirmOrderModal = observer(
  ({ order, open, isMove, setIsOpen, setIsConfirmed }: ConfirmOrderModalProps) => {
    const { viewOrderUiStore: uiStore } = useStore()

    const navigate = useNavigate()
    const { t } = useTranslation()

    const [agree, setAgree] = useState(false)
    const [loading, setLoading] = useState(false)

    const okButtonHandler = async () => {
      setLoading(true)

      if (order.id) {
        if ((await uiStore.confirmOrder(order.id, true)) && order) {
          order.confirmedToOpen = ConfirmedToOpen.true
          setIsConfirmed(true)

          /* Для синхронизации данных с бека */
          await uiStore.getOrderList()
          uiStore.setSelectedOrder(uiStore.getOrder(order.id))
        }
      }

      setLoading(false)
      setIsOpen(false)
    }

    const cancelButtonHandler = async () => {
      setLoading(true)

      if (order.id) {
        await uiStore.confirmOrder(order.id, false)

        if (await uiStore.deleteOrder(order.id)) {
          navigate(LKRoutesEnum.orders)
        }
      }

      setLoading(false)
      setIsOpen(false)
    }

    const getKey = (key: string) => `${OrderKeys.orderItemPage}.${key}`

    return (
      <Modal
        title={t(getKey(isMove ? 'Ваша заявка на переезд одобрена' : 'Ваша заявка одобрена'))}
        open={open}
        onOk={okButtonHandler}
        onCancel={cancelButtonHandler}
        okText={t(getKey('Да, подтверждаю'))}
        cancelText={t(getKey('Нет, хочу удалить заявку'))}
        okButtonProps={{ loading, disabled: !agree }}
        centered
        maskClosable={false}
        closable={false}
      >
        <Flex vertical gap={16} align="flex-start">
          {isMove ? (
            <Text>{t(getKey('Если вы готовы открыть ПВЗ'))}</Text>
          ) : (
            <>
              <Text>{t(getKey('Подтвердите свою готовность'))}</Text>
              <Text>{t(getKey('При удалении заявки в первые'))}</Text>
            </>
          )}
          {isMove ? (
            <Text>{t(getKey('Подтверждаете переезд ПВЗ?'))}</Text>
          ) : (
            <Text>{t(getKey('Подтверждаете открытие ПВЗ?'))}</Text>
          )}

          <Checkbox checked={agree} onChange={(e) => setAgree(e.target.checked)}>
            {t(getKey('Да, я буду открывать ПВЗ'))}
          </Checkbox>
        </Flex>
      </Modal>
    )
  },
)
